import isStreamVideo from '@anm/helpers/is/isStreamVideo';

var checkCanDownload = function checkCanDownload(sources) {
  return !(sources !== null && sources !== void 0 && sources.some(function (s) {
    return isStreamVideo(s.path);
  }));
};

export default checkCanDownload;